export function getTextDecoration(transformer) {
    return Object.freeze({
        none: transformer.textDecoration('none'),
        underline: transformer.textDecoration('underline'),
        dashedUnderline: transformer.textDecoration('dashed-underline'),
    });
}
